export const environment = {
  production: false,
  baseUrl: 'https://4u.superlikerslabs.com',
  photosPath: 'https://superlikers-staging.s3.amazonaws.com/uploads/upload-photo'
}
